<div class="outlet-plan-component">
  @for (outlet of outletList(); track outlet.orderNumber) {
    <div
      class="select-none relative cursor-pointer p-1 pb-2 overflow-hidden"
      (click)="selectedPort.emit(outlet.id===selectedPortId() ? null : outlet);"
      [class.archived]="outlet.childDevice.status === eEntityStatus.Archived"
      [class.error]="outlet.childDevice.incidentCountBySeverity.critical"
      [class.good]="!outlet.childDevice.incidentCountBySeverity.critical && !outlet.childDevice.incidentCountBySeverity.major && !outlet.childDevice.incidentCountBySeverity.minor"
      [class.paused]="outlet.childDevice.status === eEntityStatus.Paused"
      [class.selected]="selectedPortId() === outlet.id"
      [class.unplugged]="outlet.childDevice.status === eEntityStatus.Unplugged"
      [class.warning]="(outlet.childDevice.incidentCountBySeverity.major || outlet.childDevice.incidentCountBySeverity.minor) && !outlet.childDevice.incidentCountBySeverity.critical"
    >
      @if (selectedPortId() === outlet.id) {
        <div class="absolute w-full h-full bg-gray-200 top-0 left-0"></div>
      }

      <div class="z-10 h-1/2 relative text-left">
        <i class="icon-outlet text-2xl"></i>
      </div>
      <div class="z-10 h-1/2 relative text-right">{{ outlet.orderNumber }}</div>
    </div>
  }
</div>
